<template>
  <div>
    <div class="quick-contact-top">
      <div class="container">
        <div class="quick-contact-inner">
          <span><i class="fa fa-map-marker-alt"></i> Sincan / Ankara</span>
          <a href="tel:+905079217404"><i class="fa fa-phone-alt"></i> +90 507 921 74 04</a>
          <a :href="whatsappJoinUrl" target="_blank" rel="noopener" class="quick-contact-join">
            <i class="fab fa-whatsapp"></i> WhatsApp Grubuna Katıl
          </a>
        </div>
      </div>
    </div>

    <div class="quick-contact-mobile">
      <a href="tel:+905079217404">
        <i class="fa fa-phone-alt"></i>
        <span>Ara</span>
      </a>
      <a :href="whatsappJoinUrl" target="_blank" rel="noopener">
        <i class="fab fa-whatsapp"></i>
        <span>WhatsApp</span>
      </a>
      <a :href="mapsUrl" target="_blank" rel="noopener">
        <i class="fa fa-map-marker-alt"></i>
        <span>Konum</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuickContactBar',
  data() {
    return {
      whatsappJoinUrl: `https://wa.me/905079217404?text=${encodeURIComponent('Derneğinize websitesinden katıldım, herkese merhabalar.')}`,
      mapsUrl: 'https://www.google.com/maps/place//data=!4m2!3m1!1s0x14d32f0045182ff9:0x7675f5df2b90b8b?sa=X&ved=1t:8290&ictx=111'
    }
  }
}
</script>
